import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'objectValues' })
export class ObjectValuesPipe implements PipeTransform {
    transform(value: any, args?: any[]): Array<any> {
        // create instance vars to store keys and final output
        let keyArr: any[] = Object.keys(value),
            dataArr = [];

        // loop through the object,
        // pushing values to the return array
        keyArr.forEach((key: any) => {
            dataArr.push({ 'name': key, 'value': value[key]});
        });

        // return the resulting array
        return dataArr;
    }
}

@Pipe({ name: 'contentBuilderObject' })
export class ContentBuilderObject implements PipeTransform {
    transform(data: any, args?: any[]): any {
        if (data && data.items) {
            let item = data.items[0];
            if (item) {
                if (item.type === "html" && item.content) {
                    item = JSON.parse(item.content);
                }
                return item;
            }
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-pipe/values.pipe.ts